import React, { useEffect, useState } from 'react';
import {
    Typography,
    Grid,
    Checkbox,
    Button,
    Stack,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination
} from '@mui/material';
import Alert, { AlertProps } from '@mui/material/Alert';
import { addQuoteTestList } from 'services';
import TableRowData from './TreeTable/TableRowData';
import { useDispatch, useSelector } from 'react-redux';
import SingleRowExpand from './AnalysisGrid/SingleRowExpand';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddchartOutlinedIcon from '@mui/icons-material/AddchartOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';

const PriceList = ({
    getPriceListId,
    quoteId,
    setGetSelectedRowId,
    tabStatus,
    addPriceListSubmit,
    rowCount,
    priceList,
    selectedPriceMatrixType,
    priceLocationId,
    getPageNo,
    analysisFeeResponse,
    analysisGridLoad,
    currentRowUpdate,
    getSelectedRowId,
    selectedRowDelete,
    value,
    setAnalysisFeeResponse,
    handleUpdate,
    setHasChargesStatus,
    resetSelectedIds,
    handleAddToPriceTable,
    resultTableStatus,
    setIsEnablePriceTable
}: any) => {
    const [page, setPage] = useState(0);
    const [analysisList, setAnalysisList] = useState([] as any[]);
    const [isUpdate, setIsUpdate] = useState(0);
    const [isAvailableTest, setIsAvailableTest] = useState(false);
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [isCheck, setIsCheck] = useState([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [snackbar, setSnackbar] = React.useState<Pick<
        AlertProps,
        'children' | 'severity'
    > | null>(null);

    const dispatch = useDispatch();
    let dataList: any = useSelector((state: any) => state.dataList);
    let searchResult: any = useSelector((state: any) => state.searchResult);

    useEffect(() => {
        if (page) {
            getPageNo(page);
        }
    }, [page])

    useEffect(() => {
        if (analysisFeeResponse) {
            setAnalysisList(analysisFeeResponse);
        }
    }, [analysisFeeResponse])

    useEffect(() => {
        if (quoteId) {
            analysisGridLoad(quoteId);
        }
    }, [quoteId])

    useEffect(() => {
        addPriceListSubmit();
        dispatch({ type: 'PRICE_LIST', payload: [] });
        dispatch({ type: 'ADD_DATA', payload: [] });
    }, [value])

    const handleAnalysisClick = (event: any) => {
        let item: any = [];
        dataList.map((i: any) => {
            let obj: any = {
                "code": i.code,
                "isSet": i.isSet,
                "isSubContracted": i.isSubContracted,
                "labID": i.labID,
                "labLocationID": i.labLocationID,
                "lineTotal": (i.testPrice * i.noOfSamples).toFixed(2),
                "lor": i.lor,
                "matrixType": i.matrixType,
                "matrixTypeID": i.matrixTypeID,
                "methodReference": i.methodReference,
                "nataCertified": i.nataCertified,
                "noOfSamples": i.noOfSamples,
                "quoteID": quoteId,
                "subContractorName": i.subContractorName,
                "testID": i.id,
                "testName": i.testName,
                "testPrice": i.testPrice,
                "HasCharges": true,
                "shortName": i.shortName
            }
            item.push(obj);
        });

        let filteredArr: any = item.filter(function (i, index) {
            if (item.indexOf(i) === index)
                return item;
        });

        addQuoteTestList(filteredArr).then((res: any) => {
            if (res.status === 200) {
                let response = res.data;
                response.sort((a: any, b: any) => b.id - a.id);
                dataList = [];
                item = [];
                dispatch({ type: 'ADD_DATA', payload: [] });
                dispatch({ type: 'PRICE_LIST', payload: [] });
                setAnalysisList(response);
                currentRowUpdate(response);
                setIsUpdate(1);
                tabStatus(quoteId);
                setIsAvailableTest(false);
                addPriceListSubmit();
                setGetSelectedRowId([]);
            } else if (res.status === 400) {
                setIsAvailableTest(true);
            }
        });
    }

    const handleSelectAllClick = (event: any) => {
        // Handle Select All function 
        setIsCheckAll(!isCheckAll);
        if (isCheckAll) {
            setIsCheck([]);
            priceList?.testListData.map((i: any) => {
                i.isSelected = false;
                return i.id;
            })
            setGetSelectedRowId([]);
        } else {
            let selectedAll: any;
            selectedAll = priceList?.testListData.map((i: any) => {
                i.isSelected = true;
                return i.id;
            })
            setIsCheck(selectedAll);
            setGetSelectedRowId(selectedAll);
        }
    };

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
        addPriceListSubmit();
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    const loadGrid = (arr: any) => {
        return (
            <TableRowData
                resultValue={arr?.testListData}
                selectedMatrixType={selectedPriceMatrixType}
                getPriceListId={getPriceListId}
                locationId={priceLocationId}
                isUpdate={isUpdate}
                isAvailableTest={isAvailableTest}
            />
        )
    }

    return (
        <div style={{ paddingTop: '30px' }}>
            {dataList?.length > 0 ?
                <div style={{ textAlign: 'right', marginTop: '20px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAnalysisClick}
                        disabled={dataList.length <= 0}
                        startIcon={<AddchartOutlinedIcon />}
                        tabIndex={-1}
                    >
                        Add For Analysis
                    </Button>
                </div>
                : null}
            {((priceList?.testListData?.length > 0) && (searchResult === 1)) ?
                <TableContainer>
                    <Table sx={{ minWidth: 700, border: '1px solid #ddd', marginTop: 2 }} aria-label="simple table">
                        <TableHead style={{ backgroundColor: '#003883' }}>
                            <TableRow>
                                <TableCell style={{ width: '15px' }}>
                                    <Checkbox
                                        onChange={(event) => handleSelectAllClick(event)}
                                        sx={{
                                            color: '#fff',
                                            padding: '0px',
                                            '&.Mui-checked': {
                                                color: '#fff',
                                            },
                                        }}
                                        name="rowSelected"
                                    />
                                </TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '56px' }}>Code</TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '134px' }}>Name</TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '58px' }}>Matrix Type</TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '200px' }}>Method Reference</TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '86px' }}>LORs</TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '100px' }}>Subcontracted</TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '100px' }}>NATA Certified</TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '100px' }}># of Samples</TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '100px' }}>Test Price</TableCell>
                                <TableCell style={{ color: '#fff', padding: '4px', width: '100px' }}>Line Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loadGrid(priceList)}
                        </TableBody>
                    </Table>
                    <TablePagination
                        component="div"
                        count={rowCount}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
                : null}
            {analysisList?.length > 0 ?
                <div>
                    <Typography variant="h6" gutterBottom mt={2} mb={2}>
                        Analysis Grid
                    </Typography>
                    <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Grid item xs={12} sm={12} md={12} style={{ display: 'flex', justifyContent: 'right', gap: '10px' }}>
                            {(getSelectedRowId.length > 0) ? <>
                                <div style={{ marginRight: '0px' }}>
                                    <Button
                                        variant="contained"
                                        onClick={selectedRowDelete}
                                        startIcon={<DeleteOutlineOutlinedIcon />}
                                        tabIndex={-1}
                                        color="error"
                                    >
                                        Delete
                                    </Button>
                                </div>
                                <div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<PostAddOutlinedIcon />}
                                        onClick={handleAddToPriceTable}
                                    >
                                        Add To Price Table
                                    </Button>
                                </div> </> : null}
                        </Grid>
                    </Grid>
                    <SingleRowExpand
                        pageName="Analysis"
                        data={analysisList}
                        rowCount={rowCount}
                        setAnalysisFeeResponse={setAnalysisFeeResponse}
                        handleUpdate={handleUpdate}
                        setHasChargesStatus={setHasChargesStatus}
                        setGetSelectedRowId={setGetSelectedRowId}
                        getSelectedRowId={getSelectedRowId}
                        resetSelectedIds={resetSelectedIds}
                        getPageNo={getPageNo}
                        setIsEnablePriceTable={setIsEnablePriceTable}
                    />
                    <Typography variant="caption" display="block" gutterBottom> * <b>Grouped</b> : This is part of billing group</Typography>
                    {!!snackbar && (
                        <Snackbar
                            open
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            onClose={() => setSnackbar(null)}
                            autoHideDuration={6000}
                        >
                            <Alert {...snackbar} onClose={() => setSnackbar(null)} />
                        </Snackbar>
                    )}
                </div>
                : null}
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar
                    open={isAvailableTest}
                    autoHideDuration={5000}
                    onClose={() => setIsAvailableTest(false)}
                >
                    <Alert severity="warning">
                        Selected test is already part of analysis Grid.
                    </Alert>
                </Snackbar>
            </Stack>
        </div >
    );
}

export default PriceList;
